import PlayBadge from 'app/ui-components/PlayBadge/PlayBadge';
import PropTypes from 'prop-types';
import placeHolderImage from 'public/static//images/placeholders/16_9.png';
import React from 'react';
import CONTENTO_PRESENTATION_TYPES from '../../../../domain/ContentoPresentationTypes';
import {
    createImageProxyTemplate,
    formatImageProxyUrl,
    formatUrl,
    isImageProxyTemplate,
} from '../../../../utils/svtimage';
import EditMode from '../EditMode/EditMode';
import { StyledContentItemFigure, StyledPlayIcon } from './ContentItemFigure.styles';
import { PLAY_BADGE_THEME } from '../../../PlayBadge/PlayBadge';

const ContentItemFigure = (props) => {
    const {
        content,
        defaultImage,
        showPlaceholder,
        presentation,
        editModeActivated,
        markedAsDeleted,
        autoPlayOverlay,
        playingNow,
        children,
    } = props;

    const onlyAvailableInSweden = content.item?.restrictions?.onlyAvailableInSweden;

    let id;
    let changed;
    let imageFormat;
    let imageRatio;
    let imageRatioType;
    let altText;
    if (presentation === CONTENTO_PRESENTATION_TYPES.PORTRAIT) {
        const resolvedImage = content.images.portrait;

        id = resolvedImage.id;
        changed = resolvedImage.changed;
        altText = resolvedImage.description;
        imageFormat = 'twothree';
        imageRatioType = '2-3';
    } else {
        const resolvedImage = content.images.wide;

        id = resolvedImage.id;
        changed = resolvedImage.changed;
        altText = resolvedImage.description;
        imageFormat = 'wide';
    }

    const imageTemplate = createImageProxyTemplate(id, changed);

    let src;
    if (isImageProxyTemplate(imageTemplate)) {
        src = imageTemplate ? formatImageProxyUrl(imageTemplate, imageFormat, 480, imageRatio) : defaultImage;
    } else {
        src = imageTemplate ? formatUrl(imageTemplate, 'medium') : defaultImage;
    }

    const opacity = editModeActivated ? '0.1' : undefined;

    return (
        <>
            <StyledContentItemFigure
                src={showPlaceholder || !src ? placeHolderImage : src}
                alt={altText}
                imageRatio={imageRatioType}
                blurred={opacity ? false : onlyAvailableInSweden}
                showPlaceholder={showPlaceholder}
                opacity={opacity}
                onlyAvailableInSweden={onlyAvailableInSweden}
                editModeActivated={editModeActivated}
            >
                {autoPlayOverlay && <StyledPlayIcon onlyAvailableInSweden={onlyAvailableInSweden} />}
                {!playingNow && content.badge && !editModeActivated && (
                    <PlayBadge
                        text={content?.badge?.text}
                        theme={content?.badge?.type}
                        accessibilityText={content?.badge?.altText}
                        overlay
                    />
                )}
                {playingNow && (
                    <PlayBadge
                        text="Spelas nu"
                        theme={PLAY_BADGE_THEME.PLAYING_NOW}
                        accessibilityText="Spelas nu"
                        overlay
                    />
                )}
                {editModeActivated && (
                    <EditMode markedAsDeleted={markedAsDeleted} programTitle={content.heading} />
                )}
                {children}
            </StyledContentItemFigure>
        </>
    );
};

ContentItemFigure.propTypes = {
    content: PropTypes.shape({
        images: PropTypes.shape({
            portrait: PropTypes.shape({
                id: PropTypes.string,
                changed: PropTypes.number,
                description: PropTypes.string,
            }),
            wide: PropTypes.shape({
                id: PropTypes.string,
                changed: PropTypes.number,
                description: PropTypes.string,
            }),
        }),
        badge: PropTypes.shape({
            altText: PropTypes.string,
            text: PropTypes.string,
            type: PropTypes.string,
        }),
        item: PropTypes.shape({
            restrictions: PropTypes.shape({
                onlyAvailableInSweden: PropTypes.bool,
            }),
        }),
    }).isRequired,
    defaultImage: PropTypes.string,
    showPlaceholder: PropTypes.bool,
    presentation: PropTypes.string,
    editModeActivated: PropTypes.bool,
    markedAsDeleted: PropTypes.bool,
    autoPlayOverlay: PropTypes.bool,
    playingNow: PropTypes.bool,
};

export default ContentItemFigure;
